import type { App } from 'vue'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'

import { MoriaAura } from '@/theme/primevuePreset'

export function installMoriaUi(app: App): void {
  app.use(PrimeVue, {
    theme: {
      preset: MoriaAura,
      options: { darkModeSelector: '.moria-dark', cssLayer: false },
    },
  })
  app.use(ConfirmationService)
  app.directive('tooltip', Tooltip)
}
